import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { RouteReuseStrategy } from '@angular/router';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { IonicStorageModule } from '@ionic/storage';
import { HttpClientModule } from '@angular/common/http';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { InicioPageModule } from './pages/inicio/inicio.module';
import { CartPageModule } from './pages/cart/cart.module';
import { FlagsPageModule } from './pages/flags/flags.module';

import { ComponentsModule } from './shared/components.module';
import { IntroPageModule } from './pages/intro/intro.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AngularFireModule } from "@angular/fire";

import { AngularFireDatabaseModule } from "@angular/fire/database";
import { environment } from 'src/environments/environment';

@NgModule({
  declarations: [
    AppComponent,

  ],
  entryComponents: [

  ],
  imports: [
    IonicModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    InicioPageModule,
    CartPageModule,
    IntroPageModule,
    FlagsPageModule,
    ComponentsModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    RouterModule.forRoot([], {onSameUrlNavigation: 'reload'}),
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.FIREBASE_RDB),
    AngularFireDatabaseModule
  ],
  providers: [
    AngularFireModule,
    // StatusBar,
    // SplashScreen
    // { provide: APP_BASE_HREF, useValue: '/' },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
    // { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
